module.exports = "::ng-deep .form-control {\n  font-size: 0.75rem;\n  color: rgba(255, 255, 255, 0.8); }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/camera-info-editor/camera-info-editor.component.scss
// module id = ./src/app/shared/components/camera-info-editor/camera-info-editor.component.scss
// module chunks = main